"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.claimSubmissionSchema = void 0;
var additional_security_submission_schema_1 = require("./additional-security-submission-schema");
var property_listing_submission_schema_1 = require("./property-listing-submission-schema");
exports.claimSubmissionSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        /* eslint-disable-next-line no-template-curly-in-string */
        errorMessage: '- should not have additional property ${0#}',
    },
    required: [
        'buildingOccupiedTypeCode',
        'claimTypeCode',
        'claimFilingExtensionIndicator',
        'contestedIndicator',
        'creditFinancialRecoverIndicator',
        'legalActionDescriptionText',
        'legalCostIncurredEvictionIndicator',
        'lenderOfficerFirstName',
        'lenderOfficerLastName',
        'lenderRepresentativeFullName',
        'mobileHomeLeasedLandIndicator',
        'officerLocalFaxAreaCode',
        'lenderOfficerLocalFaxNumber',
        'officerLocalTelephoneAreaCode',
        'lenderOfficerLocalTelephoneNumber',
        'postPaymentVerificationIndicator',
        'propertyListingInformationExceptionIndicator',
        'propertyTransferPartyTypeCode',
        'lenderRepresentativeLocalTelephoneNumberAreaCode',
        'lenderRepresentativeLocalTelephoneNumber',
        'propertyTitleWarrantyTypeCode',
        'cmhcLoanAccountNumber',
        'recordCreatedTimestamp',
        'recordUpdatedTimestamp',
        'recordUpdatedUserID',
    ],
    properties: {
        buildingOccupiedTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        borrowerVacatedPropertyDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        claimTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        claimFilingExtensionIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        contestedIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        courtApprovedSaleDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        creditFinancialRecoverIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        judgmentDocumentReceivedDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        judgmentInformationSentDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        commonLawLegalActionTypeCode: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters or null',
        },
        civilLawLegalActionTypeCode: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters or null',
        },
        legalActionDescriptionText: {
            type: 'string',
            minLength: 0,
            maxLength: 60,
            errorMessage: 'should have variable length up to 60 characters',
        },
        legalActionEndDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        legalActionIndicator: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters or null',
        },
        legalActionStartDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        legalCostIncurredEvictionIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        lenderOfficerFirstName: {
            type: 'string',
            minLength: 0,
            maxLength: 15,
            errorMessage: 'should have maximum length of 15 characters',
        },
        lenderOfficerLastName: {
            type: 'string',
            minLength: 0,
            maxLength: 20,
            errorMessage: 'should have maximum length of 20 characters',
        },
        lenderRepresentativeFullName: {
            type: 'string',
            minLength: 0,
            maxLength: 30,
            errorMessage: 'should have maximum length of 30 characters',
        },
        lenderTitleAcquiredDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        mobileHomeLeasedLandIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        mortgagePaymentDeferralCount: {
            type: ['integer', 'null'],
            minimum: 0,
            maximum: 32767,
            errorMessage: 'should be an integer between 0 and 32767 or null',
        },
        officerLocalFaxAreaCode: {
            type: 'string',
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        lenderOfficerLocalFaxNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 7,
            errorMessage: 'should have maximum length of 7 characters',
        },
        officerLocalTelephoneAreaCode: {
            type: 'string',
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        lenderOfficerLocalTelephoneNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 7,
            errorMessage: 'should have maximum length of 7 characters',
        },
        postPaymentVerificationIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        purchaseOfferAcceptedDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        propertyListingInformationExceptionIndicator: {
            type: 'string',
            minLength: 0,
            maxLength: 1,
            errorMessage: 'should have maximum length of 1 characters',
        },
        propertyTransferPartyTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        lenderRepresentativeLocalTelephoneNumberAreaCode: {
            type: 'string',
            minLength: 0,
            maxLength: 3,
            errorMessage: 'should have maximum length of 3 characters',
        },
        lenderRepresentativeLocalTelephoneNumber: {
            type: 'string',
            minLength: 0,
            maxLength: 7,
            errorMessage: 'should have maximum length of 7 characters',
        },
        propertyTitleWarrantyTypeCode: {
            type: 'string',
            minLength: 0,
            maxLength: 2,
            errorMessage: 'should have maximum length of 2 characters',
        },
        underwritingDocumentReceivedDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        underwritingDocumentRequestedDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        underwritingReviewEndDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        underwritingReviewStartDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        cmhcLoanAccountNumber: {
            type: 'integer',
            minimum: 0,
            maximum: 2147483648,
            errorMessage: 'should be an integer between 0 and 2147483648',
        },
        cmhcMortgagePossessionDate: {
            type: ['string', 'null'],
            format: 'date',
            errorMessage: 'should follow date format YYYY-MM-DD or null',
        },
        recordCreatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedUserID: {
            type: 'string',
            minLength: 0,
            maxLength: 8,
            errorMessage: 'should have maximum length of 8 characters',
        },
        additionalSecuritySubmissions: {
            type: ['array', 'null'],
            items: additional_security_submission_schema_1.additionalSecuritySubmissionSchema,
        },
        propertyListingSubmissions: {
            type: ['array', 'null'],
            items: property_listing_submission_schema_1.propertyListingSubmissionSchema,
        },
    },
};
